
export default {
    data() {
        return {
            tab: 0,
        }
    },
}
